export enum BalanceCajeroTransacciones {
    ABONO = 'ABONO',
    DEBITO = 'DEBITO'
}